// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sPlant_Vend_Initial_Price"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "AccountNum",
      label: "供应商",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "12rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short"
    },
    {
      key: "TEC_CustAccount",
      label: "客户账户",
      sortable: true
    },
    {
      key: "DW_CustName",
      label: "客户名称",
      sortable: true
    },
    {
      key: "QuantityAmountFrom",
      label: "初始报价数量(从)",
      sortable: true,
      type: "number"
    },
    {
      key: "QuantityAmountTo",
      label: "初始报价数量(到)",
      sortable: true,
      type: "number"
    },
    {
      key: "Amount",
      label: "初始含税报价",
      sortable: true,
      type: "number"
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "AmountWOTax",
      label: "初始本币净单价",
      width: "8rem"
    },
    {
      key: "TaxGroup",
      label: "税组",
      sortable: true
    },
    {
      key: "FromDate",
      label: "开始日期",
      sortable: true,
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      sortable: true,
      type: "date"
    },
    { key: 'QuotationTaskNum', label: '报价申请编号', sortable: true, thStyle: { width: "125px" } },
    { key: 'ConsultQuoteNum', label: '询价单编号', sortable: true, thStyle: { width: "120px" } },
    { key: 'quotationType', label: '报价类型', sortable: true, thStyle: { width: "120px" } },
    {
      key: "Remark",
      label: "价格备注",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "VIQApprover",
      label: "报价待审批人",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "fcCheckDocumentApproved",
      label: "审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckDocumentApproved",
      context: ["待审批", "已审批"]
    }
  ],
  default_all: [
    {
      key: "id",
      label: "编号"
    },
    {
      key: "AccountNum",
      label: "供应商"
    },
    {
      key: "SEI_Name",
      label: "供应商名称"
    },
    {
      key: "ItemId",
      label: "物料编号"
    },
    {
      key: "NameAlias",
      label: "物料名称"
    },
    {
      key: "VariantName",
      label: "变型名称"
    },
    {
      key: "TEC_CustAccount",
      label: "客户账户"
    },
    {
      key: "DW_CustName",
      label: "客户名称"
    },
    {
      key: "QuantityAmountFrom",
      label: "初始报价数量(从)"
    },
    {
      key: "QuantityAmountTo",
      label: "初始报价数量(到)"
    },
    {
      key: "Amount",
      label: "初始含税报价"
    },
    {
      key: "AmountWOTax",
      label: "初始本币净单价"
    },
    {
      key: "CurrencyCode",
      label: "币种"
    },
    {
      key: "TaxGroup",
      label: "税组",
      editable: true,
      sortable: true
    },
    {
      key: "FromDate",
      label: "开始日期",
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      type: "date"
    },
    { key: 'quotationType', label: '报价类型', sortable: true, thStyle: { width: "120px" } },
    {
      key: "Remark",
      label: "价格备注",
      sortable: true
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      type: "datetime"
    },
    {
      key: "is_approved",
      label: "审批",
      type: "boolean"
    }
  ],
  invent_fields: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "TEC_CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "DW_CustName",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "10rem"
      }
    },
    {
      key: "TEC_NetArea",
      label: "净面积",
      sortable: true,
      type: "number"
    },
    {
      key: "TEC_Weight",
      label: "单位重量",
      sortable: true,
      type: "number"
    },
    {
      key: "DW_InventUnitId",
      label: "单位",
      sortable: true
    }
  ],
  item_fileds: [
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true,
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "12rem"
    },
    {
      key: "RetailVariantId",
      label: "变型名称",
      sortable: true,
      editable: true,
      type: "short",
      width: "12rem"
    },
    {
      key: "AccountNum",
      label: "供应商",
      sortable: true,
      width: "60px"
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true,
      thStyle: {
        width: "12rem"
      },
      width: "12rem"
    },
    {
      key: "QuantityAmountFrom",
      label: "报价数量(从)",
      sortable: true,
      editable: true,
      type: "number",
      width: "10rem"
    },
    {
      key: "QuantityAmountTo",
      label: "报价数量(至)",
      sortable: true,
      editable: true,
      type: "number",
      width: "10rem"
    },
    {
      key: "Amount",
      label: "初始含税报价",
      sortable: true,
      editable: true,
      type: "just_number"
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true,
      editable: true,
      width: "10rem"
    },
    {
      key: "TaxGroup",
      label: "税组",
      editable: true,
      sortable: true,
      width: "10rem"
    },
    {
      key: "AmountWOTax",
      label: "初始报价本币净单价",
      width: "10rem"
    },
    {
      key: "FromDate",
      label: "开始日期",
      sortable: true,
      editable: true,
      type: "date"
    },
    {
      key: "ToDate",
      label: "结束日期",
      sortable: true,
      editable: true,
      type: "date"
    },
    {
      key: "Remark",
      label: "价格备注",
      sortable: true,
      editable: true,
      type: "textarea"
    }
  ]
}

const dataForm = {
  id: "",
  ItemId: "",
  dataAreaId: "",
  AccountNum: "",
  SEI_Name: "", ///供应商名称
  NameAlias: "",
  RetailVariantId: "", //变形名称
  VariantName: "",
  TEC_CustAccount: "",
  DW_CustName: "",
  QuantityAmountFrom: "",
  QuantityAmountTo: "",
  Amount: "",
  AmountWOTax: "",
  TaxGroup: "",
  FromDate: "",
  ToDate: "",
  Remark: "",
  CurrencyCode: "",
  quotationType: "大货报价",//报价类型
  ConsultQuoteVendPriceId: ""
}

///前端验证
const rules = {}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const methods = {
  //get
  async getData(_params) {
    // let _fields = _.map(fields.default, "key");
    let _fields_all = _.map(fields.default_all, "key")
    _fields_all.push("RetailVariantId")
    _fields_all.push("fcGetDocumentApprover('VendInitialQuote','',t.id)")
    _fields_all.push("fcCheckDocumentApproved('VendInitialQuote','',t.id)")
    let _actions = []
    _actions.push(
      biz_data
        .selectAction({
          params: _params,
          fields: _fields_all
        })
        .action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  async getDataSql(_params) {
    let sql_biz_data = new biz_data_helper.base_entity_helper("get_vend_price_initail", {}, {})
    let f = _.map(fields.default, "key")
    let result = await sql_biz_data.execAction({
      params: _params,
      fields: f
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getSimpleData(_params) {
    let _fields = _.map(fields.default, "key")
    _fields.push("RetailVariantId")
    let _actions = []

    _actions.push(
      biz_data
        .selectAction({
          params: _params,
          fields: _fields
        })
        .action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///save
  async saveData(items) {
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )
    let add_list = [],
      update_list = []
    _.each(items, t => {
      if (_.isInteger(t.id)) {
        update_list.push(t)
      } else {
        add_list.push(t)
      }
    })

    let batch_actions = []
    if (add_list.length > 0) {
      _.each(add_list, t => {
        let _new = _.cloneDeep(dataForm)
        for (var i in _new) {
          if (t[i])
            _new[i] = t[i]
        }
        delete _new.id
        batch_actions.push(
          biz_data
            .insertAction({
              params: _new,
              fields: ["id"]
            })
            .action({
              output_last_item_map: {
                id: "id"
              }
            })
        )
        ///外部供应商初始报价审批
        let price_form = {
          itemId: "",
          documentType: "VendInitialQuote",
          approveType: "",
          documentCreateByUsername: t.create_by_username
        }
        batch_actions.push(
          so_approve_biz_data
            .execAction({
              params: price_form,
              fields: ["id"]
            })
            .action({
              mixin_last_item_map: {
                itemId: "id"
              }
            })
        )
        batch_actions.push(
          biz_data
            .updateAction({
              params: { id: "", Remark: _new.Remark },
              fields: ["id"]
            })
            .action({
              mixin_last_item_map: {
                id: "id"
              }
            })
        )
      })
    }

    if (update_list.length > 0) {
      _.each(update_list, t => {
        let _new = _.cloneDeep(dataForm)
        for (var i in _new) {
          _new[i] = t[i]
        }
        batch_actions.push(
          biz_data
            .updateAction({
              params: _new,
              fields: ["id"]
            })
            .action({})
        )
        ///外部供应商初始报价审批
        let price_form = {
          itemId: t.id,
          documentType: "VendInitialQuote",
          approveType: "",
          documentCreateByUsername: t.create_by_username
        }
        batch_actions.push(
          so_approve_biz_data
            .execAction({
              params: price_form,
              fields: ["id"]
            })
            .action({})
        )
      })
    }

    let result = await api.query_batch({
      actions: batch_actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  async saveDataDefaultApproved(items) {
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )
    let add_list = [],
      update_list = []
    _.each(items, t => {
      if (_.isInteger(t.id)) {
        update_list.push(t)
      } else {
        add_list.push(t)
      }
    })

    let batch_actions = []
    if (add_list.length > 0) {
      _.each(add_list, t => {
        let _new = _.cloneDeep(dataForm)
        for (var i in _new) {
          _new[i] = t[i]
        }
        delete _new.id
        batch_actions.push(biz_data.insertAction({ params: _new, fields: ["id"] }).action({ output_last_item_map: { id: "id" } }))
        ///外部供应商初始报价审批
        let price_form = {
          itemId: "",
          documentType: "VendInitialQuote",
          approveType: "",
          documentCreateByUsername: t.create_by_username,
          IsDefaultApproved: 1
        }
        batch_actions.push(
          so_approve_biz_data
            .execAction({
              params: price_form,
              fields: ["id"]
            })
            .action({
              mixin_last_item_map: {
                itemId: "id"
              }
            })
        )
        batch_actions.push(
          biz_data
            .updateAction({
              params: { id: "", Remark: _new.Remark },
              fields: ["id"]
            })
            .action({
              mixin_last_item_map: {
                id: "id"
              }
            })
        )
      })
    }

    if (update_list.length > 0) {
      _.each(update_list, t => {
        let _new = _.cloneDeep(dataForm)
        for (var i in _new) {
          _new[i] = t[i]
        }
        batch_actions.push(
          biz_data
            .updateAction({
              params: _new,
              fields: ["id"]
            })
            .action({})
        )
        ///外部供应商初始报价审批
        let price_form = {
          itemId: t.id,
          documentType: "VendInitialQuote",
          approveType: "",
          documentCreateByUsername: t.create_by_username
        }
        batch_actions.push(
          so_approve_biz_data
            .execAction({
              params: price_form,
              fields: ["id"]
            })
            .action({})
        )
      })
    }

    let result = await api.query_batch({
      actions: batch_actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///approve
  async approveData(items) {
    let _actions = []
    const update_status_biz_data = new biz_data_helper.base_entity_helper(
      "update_approve_status",
      {},
      {}
    )
    _.each(items, t => {
      _actions.push(
        update_status_biz_data
          .execAction({
            params: {
              IsApproved: t.is_approved == true ? 1 : 0,
              ApproveBy: t.local_username,
              status_id: t.status_id
            },
            fields: ["is_update_ok"]
          })
          .action({
            output_last_item_map: {
              is_update_ok: "is_update_ok"
            }
          })
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  },
  ///del
  async deleteData(items) {
    let _actions = []

    _.each(items, t => {
      _actions.push(
        biz_data
          .deleteAction({
            params: {
              id: t.id
            },
            fields: ["id", "deleted_by", "deleted_at"]
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  }
}
export { biz_data, dataForm, fields, methods, rules }

